module.exports = __webpack_public_path__ + "img/player_turn_004.36c30d43.png";